<template>
  <div class="system-setting-container">
    <!-- 数据表格 -->
    <div class="content-wrapper">
      <div class="table-toolbar">
        <span class="page-title">角色管理</span>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增角色</el-button>
      </div>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="roleName" label="角色名称" min-width="120" align="center" />
        <el-table-column prop="roleCode" label="角色编码" min-width="120" align="center" />
        <el-table-column prop="description" label="描述" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleAssignMenu(row)">分配权限</el-button>
            <el-button type="text" size="small" style="color: #F56C6C" v-if="row.roleCode !== 'SUPER_ADMIN'" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <Pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <RoleForm
      :visible.sync="formVisible"
      :form-data="roleFormData"
      @success="getList"
    />

    <!-- 分配菜单权限弹窗 -->
    <AssignMenu
      :visible.sync="assignMenuVisible"
      :role-id="currentRoleId"
      :role-name="currentRoleName"
    />
  </div>
</template>

<script>
import { getRoleList, deleteRole } from '@/api/role'
import Pagination from '@/components/Pagination/index.vue'
import RoleForm from './roleForm.vue'
import AssignMenu from './assignMenu.vue'

export default {
  name: 'SystemSetting',
  components: { Pagination, RoleForm, AssignMenu },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      formVisible: false,
      roleFormData: null,
      assignMenuVisible: false,
      currentRoleId: null,
      currentRoleName: ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取角色列表
    getList() {
      this.tableLoading = true
      getRoleList(this.queryParams).then(res => {
        // 后端返回纯数组 Result<List<SysRole>>，兼容分页格式
        const data = res.data
        if (Array.isArray(data)) {
          this.tableData = data
          this.total = data.length
        } else {
          this.tableData = data.records || data.list || []
          this.total = data.total || 0
        }
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.tableLoading = false
      })
    },

    // 新增角色
    handleAdd() {
      this.roleFormData = null
      this.formVisible = true
    },

    // 编辑角色
    handleEdit(row) {
      this.roleFormData = { ...row }
      this.formVisible = true
    },

    // 分配菜单权限
    handleAssignMenu(row) {
      this.currentRoleId = row.id
      this.currentRoleName = row.roleName
      this.assignMenuVisible = true
    },

    // 删除角色
    handleDelete(row) {
      this.$confirm('确定要删除该角色吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRole(row.id).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.system-setting-container {
  height: 100%;
}
</style>
